import { render, staticRenderFns } from "./ModalTransmissionNew.vue?vue&type=template&id=0a752211&"
import script from "./ModalTransmissionNew.vue?vue&type=script&lang=js&"
export * from "./ModalTransmissionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports